import React from 'react';
import { onChange, validateForm } from './../../utils';

class ComponentName extends React.Component<any, any>{
    constructor(props: any) {
        super(props);
        this.state = {
            userCode: props.userCode,
            password: { name: 'password', value: '', error: '', isRequired: true },
        }
    }

    render() {
        const { password } = this.state;
        return (
            <form onSubmit={this.onSubmit}>
                <div className="row">
                    <div className="col-md-12">
                        <div className="form-group">
                            <label>New password <sup>*</sup></label>
                            <input
                                type="password"
                                className={password.error.length > 0 ? 'form-control is-invalid' : 'form-control'}
                                placeholder="Enter new password"
                                name={password.name}
                                value={password.value}
                                onChange={this.onChange}
                            />
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-9">
                        &nbsp;
                                                </div>
                    <div className="col-md-3">
                        <button type="submit" className="btn btn-block submit-button btn-sm">Submit</button>
                    </div>
                </div>
            </form>
        )
    }

    onChange = (e: any) => {
        const name = e.target.name;
        const value = e.target.value;
        onChange(this, name, value);
    }

    onSubmit = (e: any) => {
        e.preventDefault();
        if (validateForm(this)) {
            const { userCode, password } = this.state
            this.props.onSubmit({ userCode: userCode, password: password.value });
        }
    }
}

export default ComponentName;